<template lang="html">
	<div>
	    <!--搜索-->
		<article class="rightMenu ">
			 <!--线上-->
            <div class="onLineExam" >
                 <!--搜索-->
                <div class="ExamSearchBtn cb mt10">
                    <el-col :span="24"
                        class="toolbar">
                        <el-form :inline="true">
                                <el-form-item>
                                    <el-input v-model="name" placeholder="考试名称"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary"
                                                @click="searchBtn()">查询</el-button>
                                </el-form-item>
                        </el-form>
                    </el-col>
                </div>
                <!--课程-->
	    	 	<div class="course-list cb mt20 mb20 in-exam"  v-for="(item,index) in onLineDataList" :key="index">
	    	 	  	  <dl>
	    	 	  	  	 <dd class="fl pr">
	    	 	  	  	 	 <p><img :src="item.courseLogoUrl" alt="封面" width="225" height="125"/></p>
	    	 	  	  	 	 <span class="pa f12 tc">{{ exam_statuses[item.userExamStatus] }}</span>
	    	 	  	  	 </dd>
	    	 	  	  	 <dt class="fr">
	    	 	  	  	    <div class="course-title">
	    	 	  	  	    	<p class="fl f16">{{ item.examName }}</p>
	    	 	  	  	    </div>
	    	 	  	  	    <div class="column-wrap">
	    	 	  	  	    	<div class="column-text fl">
								   <p class="mt20 f14 pr10">共{{item.totalQuestionNumbers}}题，限时{{item.examDuration}}分钟</p>
	    	 	  	  	    	</div>
                                 <div class="column-btn column-btn-green fl" v-if="item.userExamStatus == 0">
	    	 	  	  	    	 	  <button @click="examCheck(item.examId)">开始考试</button>
	    	 	  	  	    	 </div>
	    	 	  	  	    	<!--  <div class="column-btn column-btn-green fl" v-if="item.isPassed == 0 && item.userExamStatus == '2' && item.times == 0">
	    	 	  	  	    	 	  <button @click="applySupplementary(item.examId)">申请补考</button>
	    	 	  	  	    	 </div>-->
	    	 	  	  	    	 <div class="column-btn-list column-btn-blue fl mt20">
	    	 	  	  	    	 	  <button class="Clearfix" v-if="item.userExamStatus == 1" @click="examCheck(item.examId)">继续考试</button>
	    	 	  	  	    	 </div>
                                <div class="column-btn-list column-btn-yellow fl mt20">
	    	 	  	  	    	 	  <button class="Clearfix column-btn2 mt30" v-if="item.userExamStatus == 2" @click="lookOver(item.lastExamRecordId)">查看</button>
                                       <button class="Clearfix column-btn" v-if="item.userExamStatus == 2" @click="examCheck(item.examId)" style="margin-top:5px!important;">重新考试</button>
	    	 	  	  	    	 </div>
							</div>
	    	 	  	  	 </dt>
	    	 	  	  </dl>
	    	 	 </div>
				<!--		无内容-->
				<p class="tc mt50 mb30" v-if="totalItems=='0'"><img src="/static/images/nodata.png"></p>
				<!-- 分页 -->
                <div class="block" v-if="totalItems>'0'">
                    <el-pagination @size-change="handleSizeChange2"
                            @current-change="handleCurrentChange2"
                            :current-page="curPage"
                            :page-sizes="[5,10, 20, 50, 100]"
                            :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalItems">
                    </el-pagination>
                </div>
            </div>
        </article>
	    <!--查看学员信息-->
		<div class="dialogwrap baseWarp">
			<el-dialog :close-on-click-modal="false"
						:show-close="true"
						:close-on-press-escape="false"
						:visible.sync="enrollEditDialog"
						:append-to-body='true'
						title="报名信息"
						width="800px"
						>
				<v_enrollEdit ref="refenrollEdit"></v_enrollEdit>
			</el-dialog>
		</div>

	</div>
</template>
<style>
.menu-bar ul li {
  float: left;
  line-height: 40px;
  cursor: pointer;
  padding: 0 10px;
}
.menu-bar ul li:hover,
.menu-bar ul li.active {
  color: #0b60a2;
}
.nocontent {
  color: #666;
  font-size: 28px;
  text-align: center;
  padding: 40px 0;
}
.examWrap {
  height: 150px;
  background: #fff;
}
.examInfo {
  width: 95%;
}
.examInfo h3 {
  color: #5d5d5d;
  font-weight: bold;
}
.examList p {
  color: #545454;
}
.examList p .num {
  color: #409eff;
}
.menu-bar h3 {
  line-height: 40px;
  color: #606266;
}
.ExamSearchBtn {
  background: #fff;
  height: auto;
  overflow: hidden;
}
.ExamSearchBtn .toolbar {
  margin-bottom: -10px;
  border-bottom: none;
}
.examBtn {
  right: 0;
  top: 50%;
}
</style>

<script>
import enrollEdit from './enrollEdit.vue'
export default {
  data() {
    return {
       options: [],
      /*省市数组*/
      province: [],
      city: [],
      exam_statuses: {
        0: '未考试',
        1: '考试中',
        2: '已考完'
      },
      ruleForm: {
        examId: '',
        provinceOptions: [],
        projectOptions: [],
        projectId: '',
        cityOptions: [],
        city: '',
        province: ''
      },
      value: '',
      totalItems: 0,
      pageSize: 5,
      curPage: 1,
      name: '',
      examTableList: [],
      onLineDataList: [],
      enrollEditDialog: false
    }
  },
  components: {
    v_enrollEdit: enrollEdit,
  },
  methods: {
    /*线上考试列表 */
    onLineData() {
      this.$axiosPackag.get('/api/student/onlineExam/list', { 'name': this.name, 'curPage': this.curPage, 'pageSize': this.pageSize }, res => {
        this.onLineDataList = res.rows
        this.totalItems = res.total
      });
    },
    addChannel(id) {
      this.enrollEditDialog = true;
      setTimeout(() => {
        this.$refs.refenrollEdit.init(id)
      }, 0)
    },
    /*校验考试状态*/
    examCheck(examId) {
      this.id = examId
	  this.$axiosPackag.getMessageByAxios("GET", "/api/student/onlineExam/checkExamination", { "id": this.id }, null, null, res => {
        if (status == 0) {
			/*let routeData = this.$router.resolve({ path: '/exampaper', query: { id: examId } });
			window.open(routeData.href, '_blank');*/
            window.open("https://"+document.domain+"/index.html#/exampaper?id="+examId, '_blank');
        } else {
          this.$message.error(res.message);
        }
      });
    },
    /*查看*/
    lookOver(id) {
        let routeData = this.$router.resolve({ path: '/examscore', query: { id: id } });
		window.open(routeData.href, '_blank');
    },
    enrollBtn(id) {
      this.addChannel(id, '')
    },
    // 刷新关闭弹窗
    refresh(reload) {
      this.enrollEditDialog = false;
    },
    searchBtn() {
      this.curPage = 1;
      this.onLineData();
    },
    /*分页 */
  handleSizeChange2: function (size) {
      this.pageSize = size
      this.$nextTick(() =>
          this.onLineData()
      )
  },
   handleCurrentChange2: function (curPage) {
      this.curPage = curPage
      this.onLineData()
    },
  },
  mounted() {
    this.onLineData();
  }
}
</script>




// WEBPACK FOOTER //
// MyExam.vue?17fa2029